import { motion } from 'framer-motion'

/**
 * Floating Action Button Component
 * Combined unit with two attached buttons:
 * - Back to Top (top half)
 * - Contact (bottom half)
 */
const FloatingActionButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const scrollToContact = () => {
    const element = document.querySelector('#contact')
    if (element) {
      const headerOffset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <motion.div
        className="relative bg-white rounded-2xl shadow-2xl overflow-hidden"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.5 }}
        whileHover={{ scale: 1.05 }}
      >
        {/* Back to Top Button (Top Half) */}
        <motion.button
          onClick={scrollToTop}
          className="w-16 h-14 bg-gradient-to-r from-primary-600 to-primary-700 text-white flex items-center justify-center transition-all duration-300 hover:from-primary-700 hover:to-primary-800 group relative overflow-hidden"
          aria-label="Back to Top"
          whileTap={{ scale: 0.95 }}
        >
          {/* Shine effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
          <svg className="w-5 h-5 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
          {/* Tooltip */}
          <span className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            Back to Top
          </span>
        </motion.button>

        {/* Divider */}
        <div className="h-px bg-primary-500/30"></div>

        {/* Contact Button (Bottom Half) */}
        <motion.button
          onClick={scrollToContact}
          className="w-16 h-14 bg-gradient-to-r from-primary-600 to-primary-700 text-white flex items-center justify-center transition-all duration-300 hover:from-primary-700 hover:to-primary-800 group relative overflow-hidden"
          aria-label="Contact"
          whileTap={{ scale: 0.95 }}
        >
          {/* Shine effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
          <svg className="w-5 h-5 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          {/* Tooltip */}
          <span className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            Contact
          </span>
        </motion.button>
      </motion.div>
    </div>
  )
}

export default FloatingActionButton

